import ko from '@tko/build.knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import templateMarkup from 'raw-loader!./historical2-issues-view.html';
import LogiCommon from '../../../app/data-framework/logi-common';
import PreferenceService from '../../../services/preference.service';
import LoginService from "../../../services/login.service";
import DataProvider from "../../../app/data-framework/data-provider";

function HistoricalIssues2View(params) {

    var self = this;
    var loaded = false;
    var dateLoaded = false;
    self.widgetDragDropContainerOptions = {};
    self.appId = 'historical2';

    self.dataProvider = DataProvider.getInstance();

    self.panels = ko.observableArray([]);
    self.fixedPanels = ko.observableArray([]);

    self.dataProvider.loadEndpointModels();
    self.dataProvider.loadFlexQueryMetadata();

    self.route = params.route;
    self.menus = params.menus;
    var link = self.route().link;
    self.currentTabFixedPanelObservable = ko.observableArray([]);

    self.currentPanelsObservable = ko.observableArray([]);
    self.subscriptions = [];

    self.tabId = ko.pureComputed(function() {
      return self.route().tabId ? self.route().tabId.toString() : '0';
    });

    self.timeZone = { id: _.get(LoginService.userObject, 'timezoneId', ''), text: _.get(LoginService.userObject, 'timezoneDisplay', '') };

    self.logiCommon = new LogiCommon();

    self.urlParams = null;

    self.selectedDateRangeValues = ko.observable();
    function handleRoute()  {
        if (self.route().params) {
            self.urlParams = self.logiCommon.getParamsObject(self.route().params);
        }

        if (!link) {
            PreferenceService.getDateRange(self.appId).then((dateRange) => {
                self.selectedDateRangeValues({
                    startDate: moment(dateRange.startDate),
                    endDate: moment(dateRange.endDate)
                });
                loaded = true;
                self.selectedDateRangeValues.valueHasMutated();
            });
        } else {
            self.dataProvider.getTokenParams(link).then(function (tokenParams) {
                if (tokenParams) {
                    self.selectedDateRangeValues({
                        startDate: moment(tokenParams.inpStartDate, 'YYYY/MM/DD'),
                        endDate: moment(tokenParams.inpEndDate, 'YYYY/MM/DD')
                    });
                } else {
                    alert('Invalid link');
                }
                loaded = true;
                self.selectedDateRangeValues.valueHasMutated();
            });
        }
    }

    handleRoute();
    self.subscriptions.push(self.route.subscribe(()=> handleRoute()));

    self.viewLevelOptions = ko.pureComputed(function () {
        //hierarchy, daterange, urlparamobject, dataFilter, daysPerWeek, hoursPerDay
        var result1 = self.logiCommon.GetHistoricalViewLevelOptions2(null, self.selectedDateRangeValues(), self.urlParams);
        if (loaded && result1.inpStartDate) {
            return result1; // : result1;
        }
        return null;
    }).extend({ notify: 'always' });

    self.subscriptions.push(self.viewLevelOptions.subscribe(function () {
        if (self.urlParams || !loaded || link) {
            return;
        }
        PreferenceService.saveDateRange('historical2', self.selectedDateRangeValues());
    }));
}

// This runs when the component is torn down. Put here any logic necessary to clean up,
// for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
HistoricalIssues2View.prototype.dispose = function () {
    var self = this;
    self.subscriptions.forEach(function (sub) {
        sub.dispose();
    });

};

export default { viewModel: HistoricalIssues2View, template: templateMarkup };
